import { computed, ref } from 'vue'

import { filterSelectedOfferABTestedPaymentMethods } from '@backmarket/nuxt-layer-payment/methods/helpers/filterABTestedPaymentMethods'
import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'

import { useFetchPickersInternal } from './composables/useFetchPickersInternal'

export function useFetchPickers() {
  const pickersResponseCacheTagHeader = ref('')

  const experiments = useExperiments()

  const response = useFetchPickersInternal()

  const isOutOfStock = computed(() => {
    if (!response.data.value && !response.pending.value) {
      return true
    }

    return response.data?.value?.isOutOfStock ?? false
  })

  const selectedOffer = computed(() => {
    if (!response.data?.value?.selectedOffer || isOutOfStock.value) {
      return null
    }

    return filterSelectedOfferABTestedPaymentMethods(
      experiments,
      response.data.value?.selectedOffer,
    )
  })

  return {
    ...response,
    pickersResponseCacheTagHeader,
    isOutOfStock,
    selectedOffer,
  }
}
